import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { BubzLogo } from "../components/BubzLogo";
import { TERMS, PRIVACY, LEGAL_UPDATED, LEGAL_EMAIL } from "../lib/legalContent";

export default function Legal({ type }) {
  const navigate = useNavigate();
  const doc = type === "privacy" ? PRIVACY : TERMS;
  const other = type === "privacy" ? { to: "/terms", label: "Terms & Conditions" } : { to: "/privacy", label: "Privacy Policy" };

  return (
    <div className="min-h-screen bg-[#FFFDF7]" data-testid={`legal-page-${type}`}>
      <header className="max-w-4xl mx-auto px-6 pt-8 flex items-center justify-between">
        <Link to="/" data-testid="legal-home-link"><BubzLogo size="md" /></Link>
        <button onClick={() => navigate(-1)} data-testid="legal-back-btn"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-slate-800 transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back
        </button>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-10">
        <span className="inline-flex items-center gap-2 rounded-full bg-[#2AB7CA]/10 text-[#2AB7CA] px-4 py-1.5 text-sm font-bold">
          <ShieldCheck className="h-4 w-4" /> Family safety first
        </span>
        <h1 className="mt-4 text-4xl sm:text-5xl font-display font-bold text-slate-900" data-testid="legal-title">{doc.title}</h1>
        <p className="text-sm text-slate-400 mt-2" data-testid="legal-updated">Last updated: {LEGAL_UPDATED}</p>
        <p className="mt-6 text-slate-600 leading-relaxed">{doc.intro}</p>

        <div className="mt-10 space-y-8">
          {doc.sections.map((s, i) => (
            <section key={i} className="rounded-3xl bg-white border border-amber-100 p-6" data-testid={`legal-section-${i}`}>
              <h2 className="text-lg font-display font-bold text-slate-900">{s.h}</h2>
              <div className="mt-3 space-y-3">
                {s.p.map((t, j) => <p key={j} className="text-sm sm:text-base text-slate-600 leading-relaxed">{t}</p>)}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-4 text-sm">
          <Link to={other.to} data-testid="legal-other-link" className="font-bold text-[#9B5DE5] hover:underline">Read our {other.label}</Link>
          <a href={`mailto:${LEGAL_EMAIL}`} data-testid="legal-contact-link" className="text-slate-500 hover:text-slate-800">{LEGAL_EMAIL}</a>
        </div>
      </main>
    </div>
  );
}
